import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { BaseText } from '../../../translation';

@Injectable()
export class PeriodTypeService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    list(): Observable<BaseText[]> {
        return this._http.get<BaseText[]>(
            `${this._appConfig.API_ENDPOINTS.USER}/period-types`,
        );
    }
}
